import React from 'react';
import AppRouter from './AppRouter';
import VkPixelTracker from './components/VkPixelTracker';
import SiteVisitTracker from './components/SiteVisitTracker';
import { registerGlobalSpeak } from './services/tts';

registerGlobalSpeak();

function App() {
  return (
    <div className="app-container">
      <VkPixelTracker />
      <SiteVisitTracker />
      <AppRouter />
    </div>
  );
}

export default App;
